export default {"src":"/_next/static/media/charting.e35e8c84.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};